<template>
  <b-modal id="caseTypeEditModal" size="xl" hide-footer @hidden="resetData">
    <b-row slot="modal-header">
      <b-col>
        <h6>{{ $t('modals.caseType.edit.header') }}</h6>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <Update v-model="updatedAction"></Update>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import Update from '../../Update'
export default {
  name: 'CaseTypeEditModal',
  components: {
    Update
  },
  data () {
    return {
      updatedAction: 0
    }
  },
  computed: {
    show () {
      return this.$store.state.modals.caseType.update.show
    },
    item () {
      return this.$store.state.modals.caseType.update.caseTypeObject
    },
    close () {
      return this.$store.state.modals.caseType.update.close
    }
  },
  watch: {
    show: function () {
      this.openModal()
    },
    item: function () {
      this.openModal()
    },
    close: function () {
      this.closeModal()
    },
    updatedAction: function () {
      if (this.updatedAction === 1) {
        this.updatedAction = 0
        this.closeModal()
      }
    }
  },
  methods: {
    openModal () {
      if (this.show === 1 && Object.entries(this.item).length > 0) {
        this.$bvModal.show('caseTypeEditModal')
        this.$store.state.modals.caseType.update.caseTypeObject = {}
        this.$store.state.modals.caseType.update.show = 0
      }
    },
    closeModal () {
      if (this.close === 1) {
        this.$store.state.modals.caseType.update.close = 0
      }
      this.$bvModal.hide('caseTypeEditModal')
    },
    resetData () {
      // console.log('zamkniety modal')
    }
  }
}
</script>
